"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrationReportResponse = exports.migrationEntityCounts = exports.reverseMigrationBatchRequest = exports.migrationBatchSummary = exports.migrationBatchDto = exports.migrationKindCount = exports.migrationReconciliationResponse = exports.migrationTotals = exports.reconciliationCheck = exports.reconciliationCheckCode = exports.mergeMigrationRowsRequest = exports.deleteMigrationRowsRequest = exports.updateMigrationRowsRequest = exports.migrationRowsResponse = exports.migrationRowsQuery = exports.migrationRowDto = exports.accountSuggestion = exports.migrationIssue = exports.migrationFix = exports.migrationIssueSeverity = exports.migrationProfilesQuery = exports.migrationProfileDto = exports.updateMappingRequest = exports.migrationFileDto = exports.mappingSuggestion = exports.columnMapping = exports.migrationUploadQuery = exports.createMigrationBatchRequest = exports.migrationBatchStatus = exports.MIGRATION_LIMITS = exports.MIGRATION_KIND_LABELS = exports.MIGRATION_FIELDS = exports.migrationKind = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
/**
 * مركز ترحيل البيانات — استقبال داتا شركة قادمة من برنامج محاسبة سابق ومراجعتها ثم
 * اعتمادها فى «دفعة ترحيل» واحدة. المسار: رفع ← مطابقة الأعمدة ← منطقة انتظار تُعدَّل ←
 * مطابقة محاسبية ← اعتماد (أو عكس كامل ما لم يُبنَ عليها).
 *
 * منطقة الانتظار لا تمس الدفاتر: الخلايا نصوص كما جاءت من الملف أو كما عدّلها المحاسب،
 * وتُفسَّر (أرقام، تواريخ، أرقام ضريبية) عند كل فحص وعند الاعتماد — فلا قيمة «محوَّلة»
 * تختلف عما يراه المستخدم فى الجدول.
 */
/** أنواع الملفات فى المرحلة ١: بيانات أساسية وأرصدة افتتاحية. */
exports.migrationKind = zod_1.z.enum([
    'accounts',
    'trial_balance',
    'customers',
    'suppliers',
    'items',
]);
/**
 * حقول كل نوع — مصدر واحد للخادم (التحقق والقالب والاعتماد) والواجهة (أعمدة الجدول).
 * المبالغ إما عمودا مدين/دائن أو عمود رصيد واحد بإشارة (موجب = مدين للميزان والعملاء،
 * ودائن للموردين — طبيعة رصيد كل منهما).
 */
exports.MIGRATION_FIELDS = {
    accounts: [
        { key: 'legacyCode', label: 'كود الحساب القديم', required: true },
        { key: 'nameAr', label: 'اسم الحساب', required: true },
        { key: 'nameEn', label: 'الاسم بالإنجليزية' },
        { key: 'legacyParentCode', label: 'كود الحساب الأب القديم' },
        { key: 'accountType', label: 'نوع الحساب', hint: 'أصول، خصوم، حقوق ملكية، إيرادات، مصروفات' },
        {
            key: 'targetCode',
            label: 'الحساب المقابل فى الدليل الجديد',
            review: true,
            hint: 'كود حساب قائم فى دليل الشركة',
        },
        {
            key: 'newParentCode',
            label: 'أو: أنشئه تحت الحساب',
            review: true,
            hint: 'كود حساب أب فى الدليل الجديد يُفتح تحته حساب بنفس الاسم',
        },
    ],
    trial_balance: [
        { key: 'accountCode', label: 'كود الحساب', required: true },
        { key: 'accountName', label: 'اسم الحساب' },
        { key: 'debit', label: 'مدين' },
        { key: 'credit', label: 'دائن' },
        { key: 'balance', label: 'الرصيد', hint: 'بإشارة: موجب مدين وسالب دائن' },
        { key: 'side', label: 'طبيعة الرصيد', hint: 'مدين / دائن — مع عمود الرصيد' },
        { key: 'targetCode', label: 'الحساب فى الدليل الجديد', review: true },
    ],
    customers: [
        { key: 'legacyCode', label: 'الكود القديم' },
        { key: 'nameAr', label: 'اسم العميل', required: true },
        { key: 'nameEn', label: 'الاسم بالإنجليزية' },
        { key: 'taxNumber', label: 'رقم التسجيل الضريبى' },
        { key: 'nationalId', label: 'الرقم القومى' },
        { key: 'phone', label: 'التليفون' },
        { key: 'email', label: 'البريد الإلكترونى' },
        { key: 'address', label: 'العنوان' },
        { key: 'paymentTermsDays', label: 'مدة السداد (يوم)' },
        { key: 'personType', label: 'النوع', hint: 'منشأة أو فرد' },
        { key: 'debit', label: 'رصيد مدين' },
        { key: 'credit', label: 'رصيد دائن' },
        { key: 'balance', label: 'الرصيد', hint: 'موجب = مستحق لنا على العميل' },
        { key: 'balanceDate', label: 'تاريخ الرصيد' },
    ],
    suppliers: [
        { key: 'legacyCode', label: 'الكود القديم' },
        { key: 'nameAr', label: 'اسم المورد', required: true },
        { key: 'nameEn', label: 'الاسم بالإنجليزية' },
        { key: 'taxNumber', label: 'رقم التسجيل الضريبى' },
        { key: 'phone', label: 'التليفون' },
        { key: 'email', label: 'البريد الإلكترونى' },
        { key: 'address', label: 'العنوان' },
        { key: 'paymentTermsDays', label: 'مدة السداد (يوم)' },
        { key: 'debit', label: 'رصيد مدين' },
        { key: 'credit', label: 'رصيد دائن' },
        { key: 'balance', label: 'الرصيد', hint: 'موجب = مستحق للمورد علينا' },
        { key: 'balanceDate', label: 'تاريخ الرصيد' },
    ],
    items: [
        { key: 'legacyCode', label: 'كود الصنف' },
        { key: 'nameAr', label: 'اسم الصنف', required: true },
        { key: 'unit', label: 'الوحدة' },
        { key: 'salePrice', label: 'سعر البيع' },
        { key: 'itemType', label: 'النوع', hint: 'مخزنى أو خدمة' },
        { key: 'quantity', label: 'الكمية الافتتاحية' },
        { key: 'unitCost', label: 'تكلفة الوحدة' },
        { key: 'totalValue', label: 'إجمالى القيمة' },
        { key: 'warehouse', label: 'المخزن' },
    ],
};
exports.MIGRATION_KIND_LABELS = {
    accounts: 'دليل الحسابات',
    trial_balance: 'ميزان المراجعة الافتتاحى',
    customers: 'العملاء وأرصدتهم',
    suppliers: 'الموردون وأرصدتهم',
    items: 'الأصناف والمخزون الافتتاحى',
};
/** حدود الاستقبال — الملف يُحلَّل فى الذاكرة على الخادم ولا يُحفظ. */
exports.MIGRATION_LIMITS = {
    maxFileBytes: 10 * 1024 * 1024,
    maxRowsPerFile: 20_000,
    maxColumns: 60,
    extensions: ['.xlsx', '.xls', '.csv', '.txt'],
};
exports.migrationBatchStatus = zod_1.z.enum(['draft', 'committed', 'reversed']);
exports.createMigrationBatchRequest = zod_1.z
    .object({
    title: zod_1.z.string().trim().min(2).max(120),
    cutoverDate: common_1.isoDate,
    /** البرنامج السابق كما يكتبه المستخدم (الأمين، QuickBooks…) — للتقرير وملفات المصدر. */
    sourceSystem: zod_1.z
        .string()
        .trim()
        .max(60)
        .transform((value) => (value === '' ? null : value))
        .nullish(),
})
    .strict();
/** معامِلات الرفع — الملف نفسه بايتات خام فى جسم الطلب واسمه فى ترويسة `x-file-name`. */
exports.migrationUploadQuery = zod_1.z
    .object({
    kind: exports.migrationKind,
    /** اسم الورقة؛ إن غاب تُختار الورقة الأقرب لمحتوى النوع. */
    sheet: zod_1.z.string().max(120).optional(),
    /** رقم صف العناوين (من ١)؛ إن غاب يُكتشف. */
    headerRow: zod_1.z.coerce.number().int().min(1).max(200).optional(),
    /** لملفات CSV: إن غاب يُكتشف (UTF-8 ثم Windows-1256). */
    encoding: zod_1.z.enum(['utf-8', 'windows-1256']).optional(),
    /** ملف مصدر محفوظ تُطبَّق مطابقته بدل الاقتراح الآلى. */
    profileId: common_1.uuid.optional(),
})
    .strict();
/** حقل ← رقم العمود (من ٠)، أو null لحقل غير مربوط. */
exports.columnMapping = zod_1.z.record(zod_1.z.string().max(40), zod_1.z.number().int().min(0).max(200).nullable());
exports.mappingSuggestion = zod_1.z.object({
    field: zod_1.z.string(),
    column: zod_1.z.number().int(),
    /** ثقة الاقتراح من ١٠٠: ١٠٠ اسم معروف حرفيًا، وأقل منه تشابه نصى. */
    score: zod_1.z.number().int(),
});
exports.migrationFileDto = zod_1.z.object({
    id: common_1.uuid,
    kind: exports.migrationKind,
    fileName: zod_1.z.string(),
    fileSize: zod_1.z.number().int(),
    format: zod_1.z.enum(['xlsx', 'xls', 'csv']),
    sheetName: zod_1.z.string().nullable(),
    sheets: zod_1.z.array(zod_1.z.string()),
    encoding: zod_1.z.string().nullable(),
    /** صف العناوين من ١. */
    headerRow: zod_1.z.number().int(),
    headers: zod_1.z.array(zod_1.z.string()),
    mapping: exports.columnMapping,
    suggestions: zod_1.z.array(exports.mappingSuggestion),
    /** أول صفوف البيانات بعد العناوين كما فى الملف. */
    preview: zod_1.z.array(zod_1.z.array(zod_1.z.string())),
    /** أول صفوف الورقة بأرقامها — لتغيير صف العناوين (يُعاد الرفع بالرقم الجديد). */
    topRows: zod_1.z.array(zod_1.z.object({ number: zod_1.z.number().int(), cells: zod_1.z.array(zod_1.z.string()) })),
    rowCount: zod_1.z.number().int(),
    profileId: common_1.uuid.nullable(),
    createdAt: zod_1.z.string(),
});
exports.updateMappingRequest = zod_1.z
    .object({
    mapping: exports.columnMapping,
    /** يحفظ هذه المطابقة «ملف مصدر» بهذا الاسم لإعادة استخدامها مع ملفات نفس البرنامج. */
    saveProfileAs: zod_1.z
        .string()
        .trim()
        .max(80)
        .transform((value) => (value === '' ? null : value))
        .nullish(),
})
    .strict();
exports.migrationProfileDto = zod_1.z.object({
    id: common_1.uuid,
    kind: exports.migrationKind,
    name: zod_1.z.string(),
    sourceSystem: zod_1.z.string().nullable(),
    headerRow: zod_1.z.number().int(),
    /** حقل ← نص العنوان كما فى ملف البرنامج السابق (لا رقم العمود: الترتيب قد يتغير). */
    columns: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    createdAt: zod_1.z.string(),
});
exports.migrationProfilesQuery = zod_1.z.object({ kind: exports.migrationKind.optional() }).strict();
exports.migrationIssueSeverity = zod_1.z.enum(['error', 'warning']);
/** إصلاح بضغطة: تعديل خلايا، أو حذف الصف، أو دمجه مع صفوف مكررة. */
exports.migrationFix = zod_1.z.object({
    label: zod_1.z.string(),
    patch: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).optional(),
    action: zod_1.z.enum(['patch', 'delete', 'merge']),
    mergeWith: zod_1.z.array(common_1.uuid).optional(),
});
exports.migrationIssue = zod_1.z.object({
    code: zod_1.z.string(),
    severity: exports.migrationIssueSeverity,
    field: zod_1.z.string().optional(),
    message: zod_1.z.string(),
    fix: exports.migrationFix.optional(),
});
exports.accountSuggestion = zod_1.z.object({
    code: zod_1.z.string(),
    nameAr: zod_1.z.string(),
    score: zod_1.z.number().int(),
});
exports.migrationRowDto = zod_1.z.object({
    id: common_1.uuid,
    kind: exports.migrationKind,
    rowNumber: zod_1.z.number().int(),
    data: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    edited: zod_1.z.boolean(),
    issues: zod_1.z.array(exports.migrationIssue),
    /** للميزان ودليل الحسابات: الحساب الذى سيُرحَّل عليه ومن أين جاء. */
    resolved: zod_1.z
        .object({
        code: zod_1.z.string(),
        nameAr: zod_1.z.string(),
        via: zod_1.z.enum(['explicit', 'chart_mapping', 'code', 'name', 'new_account']),
    })
        .nullable(),
    suggestions: zod_1.z.array(exports.accountSuggestion),
});
exports.migrationRowsQuery = zod_1.z
    .object({
    kind: exports.migrationKind,
    filter: zod_1.z.enum(['all', 'issues', 'errors']).default('all'),
    q: zod_1.z.string().max(100).optional(),
    offset: zod_1.z.coerce.number().int().min(0).default(0),
    limit: zod_1.z.coerce.number().int().min(1).max(1000).default(200),
})
    .strict();
exports.migrationRowsResponse = zod_1.z.object({
    kind: exports.migrationKind,
    fields: zod_1.z.array(zod_1.z.object({
        key: zod_1.z.string(),
        label: zod_1.z.string(),
        required: zod_1.z.boolean(),
        review: zod_1.z.boolean(),
    })),
    rows: zod_1.z.array(exports.migrationRowDto),
    total: zod_1.z.number().int(),
    offset: zod_1.z.number().int(),
    limit: zod_1.z.number().int(),
    summary: zod_1.z.object({
        rows: zod_1.z.number().int(),
        errors: zod_1.z.number().int(),
        warnings: zod_1.z.number().int(),
        rowsWithErrors: zod_1.z.number().int(),
    }),
});
/** تعديل خلايا صف أو أكثر — التعديل الجماعى نفس الطلب بصفوف كثيرة. */
exports.updateMigrationRowsRequest = zod_1.z
    .object({
    updates: zod_1.z
        .array(zod_1.z
        .object({
        rowId: common_1.uuid,
        data: zod_1.z.record(zod_1.z.string().max(40), zod_1.z.string().max(500)),
    })
        .strict())
        .min(1)
        .max(2000),
})
    .strict();
exports.deleteMigrationRowsRequest = zod_1.z
    .object({ rowIds: zod_1.z.array(common_1.uuid).min(1).max(2000) })
    .strict();
/**
 * دمج مكرر: يبقى صف واحد، وتُجمع أرصدته وكمياته من الصفوف المدموجة، والخلايا الفارغة فيه
 * تُكمَّل منها. المدموج يخرج من الدفعة ويبقى أثره فى التقرير.
 */
exports.mergeMigrationRowsRequest = zod_1.z
    .object({
    keepRowId: common_1.uuid,
    mergeRowIds: zod_1.z.array(common_1.uuid).min(1).max(50),
})
    .strict();
exports.reconciliationCheckCode = zod_1.z.enum([
    'TRIAL_BALANCE_BALANCED',
    'RECEIVABLES_MATCH',
    'PAYABLES_MATCH',
    'INVENTORY_MATCH',
    'ROWS_VALID',
    'NO_DOUBLE_OPENING',
    'PERIOD_OPEN',
]);
exports.reconciliationCheck = zod_1.z.object({
    code: exports.reconciliationCheckCode,
    title: zod_1.z.string(),
    /** `na`: لا ينطبق (لا ميزان فى الدفعة مثلاً). `warn` لا يمنع الاعتماد. */
    status: zod_1.z.enum(['ok', 'fail', 'warn', 'na']),
    expected: common_1.moneyString.nullable(),
    actual: common_1.moneyString.nullable(),
    difference: common_1.moneyString.nullable(),
    /** الشرح والمصدر المرجّح للفرق بلغة المستخدم. */
    detail: zod_1.z.string(),
    /** أكبر الصفوف أثرًا فى الفرق — للانتقال إليها. */
    suspects: zod_1.z.array(zod_1.z.object({ kind: exports.migrationKind, rowId: common_1.uuid, label: zod_1.z.string() })),
});
exports.migrationTotals = zod_1.z.object({
    trialBalanceDebit: common_1.moneyString,
    trialBalanceCredit: common_1.moneyString,
    receivables: common_1.moneyString,
    payables: common_1.moneyString,
    inventory: common_1.moneyString,
});
exports.migrationReconciliationResponse = zod_1.z.object({
    batchId: common_1.uuid,
    ready: zod_1.z.boolean(),
    checks: zod_1.z.array(exports.reconciliationCheck),
    totals: exports.migrationTotals,
    /** ما سيحدث عند الاعتماد — أعداد الإنشاء والربط والقيد. */
    plan: zod_1.z.object({
        accountsToCreate: zod_1.z.number().int(),
        customersToCreate: zod_1.z.number().int(),
        customersToLink: zod_1.z.number().int(),
        suppliersToCreate: zod_1.z.number().int(),
        suppliersToLink: zod_1.z.number().int(),
        itemsToCreate: zod_1.z.number().int(),
        itemsToLink: zod_1.z.number().int(),
        journalLines: zod_1.z.number().int(),
        stockLines: zod_1.z.number().int(),
        /** فرق يُقيَّد على حساب فروق الأرصدة الافتتاحية (دفعة بلا ميزان). */
        openingDifference: common_1.moneyString,
    }),
});
exports.migrationKindCount = zod_1.z.object({
    kind: exports.migrationKind,
    rows: zod_1.z.number().int(),
    errors: zod_1.z.number().int(),
    warnings: zod_1.z.number().int(),
});
exports.migrationBatchDto = zod_1.z.object({
    id: common_1.uuid,
    companyId: common_1.uuid,
    number: zod_1.z.string(),
    title: zod_1.z.string(),
    status: exports.migrationBatchStatus,
    cutoverDate: common_1.isoDate,
    sourceSystem: zod_1.z.string().nullable(),
    /** `platform`: أنشأها أو اعتمدها مشغّل المنصة كخدمة للعميل. */
    operator: zod_1.z.enum(['member', 'platform']),
    createdAt: zod_1.z.string(),
    committedAt: zod_1.z.string().nullable(),
    reversedAt: zod_1.z.string().nullable(),
    reversalReason: zod_1.z.string().nullable(),
    journalId: common_1.uuid.nullable(),
    journalNumber: zod_1.z.string().nullable(),
    reversalJournalNumber: zod_1.z.string().nullable(),
    files: zod_1.z.array(exports.migrationFileDto),
    counts: zod_1.z.array(exports.migrationKindCount),
});
exports.migrationBatchSummary = exports.migrationBatchDto.omit({ files: true, counts: true }).extend({
    rows: zod_1.z.number().int(),
});
exports.reverseMigrationBatchRequest = zod_1.z
    .object({ reason: zod_1.z.string().trim().min(3).max(500) })
    .strict();
exports.migrationEntityCounts = zod_1.z.object({
    created: zod_1.z.number().int(),
    linked: zod_1.z.number().int(),
});
/** تقرير الدفعة — يُكتب عند الاعتماد ولا يتغير بعده (عدا حالة العكس). */
exports.migrationReportResponse = zod_1.z.object({
    batch: exports.migrationBatchSummary,
    generatedAt: zod_1.z.string(),
    counts: zod_1.z.object({
        accounts: exports.migrationEntityCounts,
        customers: exports.migrationEntityCounts,
        suppliers: exports.migrationEntityCounts,
        items: exports.migrationEntityCounts,
        cashboxes: exports.migrationEntityCounts,
        mergedRows: zod_1.z.number().int(),
        deletedRows: zod_1.z.number().int(),
    }),
    totals: exports.migrationTotals,
    checks: zod_1.z.array(exports.reconciliationCheck),
    journal: zod_1.z
        .object({
        id: common_1.uuid,
        number: zod_1.z.string().nullable(),
        totalDebit: common_1.moneyString,
        totalCredit: common_1.moneyString,
        lines: zod_1.z.number().int(),
    })
        .nullable(),
    stock: zod_1.z.object({ items: zod_1.z.number().int(), value: common_1.moneyString }),
    /** ملاحظات لا تمنع: مخازن متعددة جُمعت، أرصدة دائنة لعملاء… */
    notes: zod_1.z.array(zod_1.z.string()),
});
//# sourceMappingURL=migration.js.map